import React from 'react';
import ReactDOM from 'react-dom/client'; // Perhatikan perubahan import ini
import './index.css';
import LoginAndGetData from './App';

// Menggunakan React 18/19 dengan createRoot
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LoginAndGetData />
  </React.StrictMode>
);
